import { HttpContextToken } from '@angular/common/http';

export const BYPASS_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
export const SUPPRESS_SESSION_EXPIRED_DIALOG = new HttpContextToken<boolean>(() => false);